(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/frejaeid/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/app/frejaeid/assets/javascripts/prescript.js'); (function(svs) {
  'use strict';

  svs = svs || {};
  svs.app = svs.app || {};
  svs.app.frejaeid = svs.app.frejaeid || {};
  svs.app.frejaeid.views = svs.app.frejaeid.views || {};
  svs.app.frejaeid.logger = svs.app.frejaeid.logger || svs.core.log.getLogger('app:frejaeid');
})(svs);

 })(window);